
<template>
    <elecBoardContainer></elecBoardContainer>
  </template>
    
  <script>
  import elecBoardContainer from "@/components/elecBoard/elecBoardContainer";
  export default {
    components: {
      elecBoardContainer,
    },
    setup() {},
  };
  </script>
    
  <style lang="scss"></style>
    